import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './common/components/header/header.component';
import { RegistryHeaderComponent } from './common/components/registry-header/registry-header.component';
import { FooterComponent } from './common/components/footer/footer.component';
import { SidebarComponent } from './common/components/sidebar/sidebar.component';
import { BreadcrumbComponent } from './common/components/breadcrumb/breadcrumb.component';
import { NotificationModule } from '@progress/kendo-angular-notification';
import { DialogsModule } from '@progress/kendo-angular-dialog';

import { LabelModule } from '@progress/kendo-angular-label';
import { EditorModule } from '@progress/kendo-angular-editor';
import { AngularDeviceInformationService } from 'angular-device-information';
import { AppProfessionalComponent } from './app-professional/app-professional.component';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { NgOtpInputModule } from 'ng-otp-input';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { TooltipsModule } from '@progress/kendo-angular-tooltip';
import { FileUploadDialogComponent } from './common/components/file-upload-dialog/file-upload-dialog.component';
import { FileSelectModule } from '@progress/kendo-angular-upload';
import { CommentDialogComponent } from './common/components/comment-dialog/comment-dialog.component';
import { GridModule } from '@progress/kendo-angular-grid';
import { CustomPipesModule } from "./common/pipes/custom-pipes.module";

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    RegistryHeaderComponent,
    FooterComponent,
    SidebarComponent,
    BreadcrumbComponent,

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NotificationModule,
    DialogsModule,
    LabelModule,
    EditorModule,
    LayoutModule,
    BrowserAnimationsModule,
    DropDownsModule,
    TooltipsModule,
    FileSelectModule,
    GridModule,
    CustomPipesModule
  ],
  providers: [AngularDeviceInformationService],
  bootstrap: [AppComponent],
})
export class AppModule { }
